import { useLingui } from '@lingui/react/macro';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';

export default function CloseButton({ onClick }: { onClick?: () => void }) {
  const { t } = useLingui();
  return (
    <IconButton
      aria-label={t({ comment: 'Close dialog button accessibility label', message: 'close' })}
      onClick={onClick}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
      }}
    >
      <CloseIcon />
    </IconButton>
  );
}
